import {
  put,
  call,
  all,
  takeLatest,
  takeEvery,
  delay,
} from "redux-saga/effects";

import { axiosDelete, axiosGet, axiosPost, axiosPut } from "../util/axios";
import { HTTP_SUCCESS_STATUSES } from "../constants/http_constants";
import { migration, region } from "../util/routers";

import * as actionType from "../constants/action_types";
import * as actions from "../actions/index";
import { toast } from "react-toastify";

function* getMigration(action) {
  try {
    //    yield put(actions.RESET_STATE("company.update_response"));
    const url = `${migration}`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETMIGRATION_RESPONSE({
        data: data.data,
        totalCount: data.totalCount,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETMIGRATION_RESPONSE(error));
  }
}

function* getMigrationDetails(action) {
  try {
    const url = `${migration}`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETMIGRATIONDETAILS_RESPONSE({
        data: data.data,
        totalCount: data.totalCount,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETMIGRATIONDETAILS_RESPONSE(error));
  }
}

function* getLoginRegion(action) {
  try {
    let neededRegion = (process.env.REACT_APP_ENV == 'development' || process.env.REACT_APP_ENV == 'staging') ? 'live' : 'staging'
    const url = `${process.env.REACT_APP_MIGRATION_URL}${region}?neededRegion=${neededRegion}`;
    let { data, status } = yield call(axiosGet, url, {});
    yield put(
      actions.GETOPPOSITEENVREGION_RESPONSE({
        data: data.data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETOPPOSITEENVREGION_RESPONSE(error));
  }
}

function* getMigrationDefaultObject(action) {
  try {
    const url = `${migration}/migrationConfigObject`;
    let { data, status } = yield call(axiosGet, url, {});
    yield put(
      actions.GETMIGRATIONDEFAULTOBJECT_RESPONSE({
        data: data.data,
        status,
        sourceCompanyDetails : data.sourceCompanyDetails,
        sourceAccountConfig : data.sourceAccountConfig
      })
    );
  } catch (error) {
    yield put(actions.GETMIGRATIONDEFAULTOBJECT_RESPONSE(error));
  }
}

function* migrationObjectValidate(action) {
  try {
    const url = `${migration}/validation`;
    const body = action.payload
    let { data, status } = yield call(axiosPost, url, body);
    yield put(
      actions.GETMIGRATIONOBJECTVALIDATE_RESPONSE({
        data: data.data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETMIGRATIONOBJECTVALIDATE_RESPONSE(error));
  }
}

function* getMigrationStatusList(action) {
  try {
    const url = `${migration}/getConfigList`;
    const body = { "migrationID": action.payload.migrationID }
    let { data, status } = yield call(axiosPost, url, body);
    yield put(
      actions.GETMIGRATIONSTATUSLIST_RESPONSE({
        data: data.data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETMIGRATIONSTATUSLIST_RESPONSE(error));
  }
}

function* getMigrationStart(action) {
  try {
    const url = `${migration}`;
    const body = action.payload
    let { data, status } = yield call(axiosPost, url, body);
    yield put(
      actions.GETMIGRATIONSTART_RESPONSE({
        data: data.data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETMIGRATIONSTART_RESPONSE(error));
  }
}

function* apikeyValidation(action) {
  try {
    const url = `${migration}/validation/apikey`;
    const body = action.payload
    let { data, status } = yield call(axiosPost, url, body);
    yield put(
      actions.APIKEYVALIDATION_RESPONSE({
        data: data.data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.APIKEYVALIDATION_RESPONSE(error));
  }
}

function* migrationWatcherSaga() {
  yield all([

    takeLatest(actionType.GETMIGRATION_REQ, getMigration),
    takeLatest(actionType.GETMIGRATIONDETAILS_REQ, getMigrationDetails),
    takeLatest(actionType.GETOPPOSITEENVREGION_REQ, getLoginRegion),
    takeLatest(actionType.GETMIGRATIONDEFAULTOBJECT_REQ, getMigrationDefaultObject),
    takeLatest(actionType.GETMIGRATIONOBJECTVALIDATE_REQ, migrationObjectValidate),
    takeLatest(actionType.GETMIGRATIONSTATUSLIST_REQ, getMigrationStatusList),
    takeLatest(actionType.GETMIGRATIONSTART_REQ, getMigrationStart),
    takeLatest(actionType.APIKEYVALIDATION_REQ, apikeyValidation)

  ]);
}

export default migrationWatcherSaga;
